/**
 * @callback modMkImgCallback
 * @param {jQuery} attfile - jQuery-объект DOM-элемента файла (.attfile).
 * @param {Object} data - Данные файла с бэкенда.
 * @param {boolean} isPost - true, если вызвано после загрузки (filePostAddImgArray), false если при инициализации.
 * @description Колбэк, вызываемый после создания HTML-блока изображения.
 *              Используется для кастомной логики (например, для обновления списка модерации в editCompetitions1).
 */

/**
 * @callback fileDelMod
 * @param {HTMLElement} attfile - DOM-элемент удаляемого файла (.attfile).
 * @description Колбэк, вызываемый при удалении файла из списка.
 *              Используется для кастомной логики (например, обновление списка модерируемых файлов в editCompetitions1).
 */

/**
 * @callback fileOnload
 * @param {Array<Object>} data - Массив данных загруженных файлов с бэкенда.
 * @param {HTMLElement} el - DOM-элемент контейнера списка (.filelist).
 * @description Колбэк, вызываемый после успешной загрузки файлов и их отрисовки в списке.
 */


/**
 * Обновление состояния Alpine.js хранилища для синхронизации файлов.
 * Вызывается после изменений в списке файлов (поворот, удаление), чтобы Alpine-компоненты
 * на странице (например, счетчики или условия показа кнопок) обновились.
 * 
 * @param {HTMLElement|jQuery} inp - DOM-элемент (или jQuery-объект), внутри которого ищется .fileform__wrapper.
 */
function updateAlpineStorage(inp) {
	if (typeof syncFilesToStore !== 'function')
		return;
	if (inp?.jquery)
		inp = inp[0];

	const wrapper = findParentByClassName(inp, 'fileform__wrapper');
	if (!wrapper)
		return;

	syncFilesToStore(wrapper);
}


const MAX_FILE_SIZE_MB = 25;
var UPLOAD_FILE_SATUSES = {
	ERROR: -1,
	LOADING: 0,
	DONE: 1
};
var draggedPic = null;
// true только во время ВНУТРЕННЕЙ сортировки картинок
// Нужен, чтобы отличать перетаскивание элемента списка от перетаскивания файла извне.
var isInternalImageDrag = false;

/**
 * Глобальный менеджер очередей загрузки файлов.
 * Отслеживает статус каждого загружаемого файла, отображает общий прогресс-бар в углу экрана
 * и блокирует отправку формы, если загрузка еще не завершена.
 * 
 * @constructor
 */
var UploadFileProcessor = function () {
	var _ = this;
	_.collection = [];

	/**
	 * Добавление файла в очередь загрузки.
	 * Создает объект статуса, добавляет его в коллекцию и генерирует CustomEvent "uploadFileProcessor.create".
	 * Также автоматически навешивает onsubmit на форму, чтобы предотвратить отправку во время загрузки.
	 * 
	 * @param {File} file - Загружаемый файл (или объект с метаданными файла).
	 * @param {HTMLElement} [target] - DOM-элемент (обычно input[type=file]), к которому привязан файл.
	 * @returns {number} Индекс файла в коллекции (используется для обновления прогресса).
	 */
	_.push = function (file, target) {

		if (typeof (target) !== "undefined") {
			var form = target.form;
			console.log("onsubmit", $(form).attr("onsubmit"));
			if (typeof ($(form).attr("onsubmit")) === "undefined") {
				$(form).attr({"onsubmit": "return checkLoadFiles();"});
			}
		}
		var file_status = _.create_file_status(file, target);
		var idx = _.collection.push(file_status) - 1;
		var event = new CustomEvent("uploadFileProcessor.create", {
			bubbles: true,
			cancelable: true,
			detail: {
				id: idx,
				fileStatus: file_status,
				target: file_status.getTarget()
			}
		});
		file_status?.getTarget()?.dispatchEvent(event);
		_.onCreate(idx, event);
		return idx;
	};

	/**
	 * Преобразование числа байтов в человекочитаемую строку (KB, MB, GB, TB).
	 * @param {number} bytes - Размер файла в байтах.
	 * @returns {string} Отформатированная строка, например "15.3 MB".
	 */
	_.byteToSize = function (bytes) {
		var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
		if (bytes === 0)
			return '0 Byte';
		var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
		return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
	};

	/**
	 * Получение объекта статуса файла по его индексу.
	 * @param {number} idx - Индекс файла в коллекции.
	 * @returns {Object|null} Объект статуса или null, если индекс выходит за пределы.
	 */
	_.getFileStatus = function (idx) {
		if (idx >= _.collection.length) {
			return null;
		}
		return _.collection[idx];
	};

	/**
	 * Создание внутреннего объекта статуса файла с геттерами и методами.
	 * @param {File} file - Файл.
	 * @param {HTMLElement} target - Целевой DOM-элемент.
	 * @returns {Object} Объект статуса (name, size, type, loaded, status, и методы getName, isDone и т.д.).
	 */
	_.create_file_status = function (file, target) {
		var status = {
			"name": file.name,
			"size": file.size,
			"type": file.type,
			"lastModified": file.lastModified,
			"loaded": 0,
			"status": UPLOAD_FILE_SATUSES.LOADING,
			"target": target,
			"getName": function () {
				return this.name;
			},
			"isDone": function () {
				return this.status !== UPLOAD_FILE_SATUSES.LOADING;
			},
			"getTarget": function () {
				return this.target;
			},
			"getSize": function () {
				return this.size;
			},
			"getLoaded": function () {
				return this.loaded;
			},
			"getLoadedPrc": function () {
				return Math.round(this.getLoaded() / this.getSize() * 100);
			},
			"getLoadedStatus": function () {
				return _.byteToSize(this.getLoaded()) + "/" + _.byteToSize(this.getSize()) + " (" + this.getLoadedPrc() + "%)";
			},
			"getTypeName": function () {
				switch (this.type) {
					case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
						return "docx";
						break;
					case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
						return "xlsx";
						break;
					case "image/png":
						return "png";
						break;
					case "image/jpeg":
						return "jpeg";
						break;
					case "application/zip":
						return "zip";
						break;
					case "application/rar":
						return "rar";
						break;
					default :
						return "none";
						break;
				}
			}
		};
		return status;
	};

	/**
	 * Обновление прогресса загрузки файла.
	 * @param {number} fileIdx - Индекс файла в коллекции.
	 * @param {ProgressEvent} event - Событие прогресса от XMLHttpRequest.
	 */
	_.progress = function (fileIdx, event) {
		var fileStatus = _.getFileStatus(fileIdx);
		//console.debug("progress", fileIdx, event, fileStatus);
		if (fileStatus === null) {
			return;
		}
		fileStatus.loaded = event.loaded;
		var event = new CustomEvent("uploadFileProcessor.progress", {
			detail: {
				id: fileIdx,
				fileStatus: fileStatus,
				target: fileStatus.getTarget()
			}
		});
		fileStatus?.getTarget()?.dispatchEvent(event);
		_.onProgress(fileIdx, event);
	};

	/**
	 * Отметка файла как успешно загруженного.
	 * @param {number} fileIdx - Индекс файла в коллекции.
	 * @param {Event} [event] - Опциональное событие.
	 */
	_.done = function (fileIdx, event) {
		var fileStatus = _.getFileStatus(fileIdx);
		if (fileStatus === null) {
			return;
		}
		fileStatus.loaded = fileStatus.size;
		fileStatus.status = UPLOAD_FILE_SATUSES.DONE;
		var event = new CustomEvent("uploadFileProcessor.done", {
			detail: {
				id: fileIdx,
				fileStatus: fileStatus,
				target: fileStatus.getTarget()
			}
		});
		fileStatus?.getTarget()?.dispatchEvent(event);
		_.onDone(fileIdx, event);
	};

	/**
	 * Отметка файла как загруженного с ошибкой.
	 * @param {number} fileIdx - Индекс файла в коллекции.
	 * @param {Event} [event] - Опциональное событие.
	 */
	_.error = function (fileIdx, event) {
		var fileStatus = _.getFileStatus(fileIdx);
		if (fileStatus === null) {
			return;
		}
		fileStatus.loaded = 0;
		fileStatus.status = UPLOAD_FILE_SATUSES.ERROR;
		var event = new CustomEvent("uploadFileProcessor.error", {
			detail: {
				id: fileIdx,
				fileStatus: fileStatus,
				target: fileStatus.getTarget()
			}
		});
		fileStatus?.getTarget()?.dispatchEvent(event);
		_.onError(fileIdx, event);
	};

	_.onCreate = function (idx, event) {
		_.onEvent(idx, event);
	};
	_.onProgress = function (idx, event) {
		_.onEvent(idx, event);
	};

	/**
	 * Проверка, завершены ли загрузку всех файлов в очереди.
	 * @returns {boolean} true, если все файлы имеют статус DONE или ERROR.
	 */
	_.onDone = function (idx, event) {
		_.onEvent(idx, event);
	};
	_.onError = function (idx, event) {
		_.onEvent(idx, event);
	};

	/**
	 * Обработчик событий загрузки (создание, прогресс, завершение, ошибка).
	 * Отвечает за отрисовку и обновление глобального прогресс-бара загрузки в углу экрана (.upload_file_processor__container).
	 * 
	 * @param {number} idx - Индекс файла.
	 * @param {CustomEvent} event - Событие с деталями загрузки.
	 */
	_.onEvent = function (idx, event) {
		//console.log("Event", idx, event);
		var upload_container = $(".upload_file_processor__container");
		if (upload_container.length === 0) {
			upload_container = $("<div></div>");
			$(upload_container).addClass("upload_file_processor__container");
			$(upload_container).appendTo("body");
		}
		if (!_.isDone()) {
			$(upload_container).show();
		}
		for (var i = 0; i < _.collection.length; i++) {
			var fileStatus = _.getFileStatus(i);
			var file_item_container = $("#ufp_item_" + i, upload_container);
			if (file_item_container.length === 0) {
				file_item_container = $("<div></div>");
				$(file_item_container).addClass("ufp__item");
				$(file_item_container).attr({"id": "ufp_item_" + i});
				$(file_item_container).attr({"data-ufpItemId": i});
				$(file_item_container).on("click", function (event) {
					event = event.originalEvent || event;
					var target = event.target;
					if (!$(target).hasClass("ufp__item")) {
						target = $(target).parents(".ufp__item");
					}
					var idx = $(target).attr("data-ufpItemId");
					var file_target = UPLOAD_FILS.getFileStatus(idx).getTarget();
					var fileform = $(file_target).parents(".fileform");
					$([document.documentElement, document.body]).animate({
						scrollTop: $(fileform).offset().top
					}, 300);
					//$('body').scrollTo(inputform);
				});
				$(file_item_container).appendTo(upload_container);
			}
			var file_icon = $(".ufp__icon", file_item_container);
			if (file_icon.length === 0) {
				file_icon = $("<div></div>");
				$(file_icon).addClass("ufp__icon");
				$(file_icon).addClass(fileStatus.getTypeName());
				$(file_icon).appendTo(file_item_container);
			}
			var file_body = $(".ufp__body", file_item_container);
			if (file_body.length === 0) {
				file_body = $("<div></div>");
				$(file_body).addClass("ufp__body");
				$(file_body).appendTo(file_item_container);
			}
			var file_title = $(".ufp__title", file_body);
			if (file_title.length === 0) {
				file_title = $("<div></div>");
				$(file_title).addClass("ufp__title");
				$(file_title).appendTo(file_body);
			}
			$(file_title).html(fileStatus.getName());

			var file_progress_bar = $(".ufp__progress_bar", file_body);
			if (file_progress_bar.length === 0) {
				file_progress_bar = $("<div></div>");
				$(file_progress_bar).addClass("ufp__progress_bar");
				$(file_progress_bar).appendTo(file_body);
			}
			var file_progress = $(".ufp__progress", file_progress_bar);
			if (file_progress.length === 0) {
				file_progress = $("<div></div>");
				$(file_progress).addClass("ufp__progress");
				$(file_progress).appendTo(file_progress_bar);
			}
			$(file_progress_bar).css({
				"background": "linear-gradient(90deg, #5b85f1 0%, #5b85f1 " + fileStatus.getLoadedPrc() + "%, #fff " + fileStatus.getLoadedPrc() + "%, #fff 100%)",
			});
			$(file_progress).css({
				"width": "inherit",
				"background": "linear-gradient(90deg, #000 0%, #000 " + fileStatus.getLoadedPrc() + "%, #fff " + fileStatus.getLoadedPrc() + "%, #fff 100%)",
				"-webkit-background-clip": "text",
				"background-clip": "text",
				"color": "transparent",
				"text-align": "center",
				"filter": "invert(1)"
			});
			$(file_progress).html(fileStatus.getLoadedStatus());
			if (fileStatus.isDone()) {
				$(file_item_container).fadeOut();
			}
		}
		if (_.isDone()) {
			$(upload_container).fadeOut();
		}
	};
	_.isDone = function () {
		var done = true;
		for (var idx = 0; idx < _.collection.length; idx++) {
			if (!_.getFileStatus(idx).isDone()) {
				done = false;
				break;
			}
		}
		return done;
	};
	return _;
};
var UPLOAD_FILS = new UploadFileProcessor();


/**
 * Проверка перед отправкой формы: все ли файлы загружены.
 * Используется как onsubmit-валидатор для форм с загрузкой файлов.
 * @returns {boolean} true, если все загрузки завершены, иначе false (и показывает алерт).
 */
function checkLoadFiles() {
	if (!UPLOAD_FILS.isDone()) {
		aAlert("Дождитесь окончание загрузки файлов.");
		return false;
	}
	return true;
}

/**
 * Загрузка ОДНОГО изображения с предпросмотром в конкретный блок (не в список).
 * Используется, где нужно сразу показать превью в background.
 * 
 * @param {HTMLInputElement} fileInp - Input[type=file], из которого берется файл.
 * @param {HTMLInputElement} targetImp - Скрытый input, в который запишется ID загруженного файла.
 * @param {HTMLElement} targetBg - DOM-элемент, на который установится background-image с превью.
 */
function fileChangeSingleImg(fileInp, targetImp, targetBg) {
	var data = new FormData();
	var files = fileInp.files;
	if (!files && files.length == 0) {
		return;
	}
	data.append(0, files[0]);
	fileInp.value = "";
	var target = fileInp;
	var upload_file_idx = UPLOAD_FILS.push(files[0], target);
	jQuery.ajax({
		url: 'fileUpload',
		type: 'POST', // важно!
		data: data,
		cache: false,
		dataType: 'html',
		// отключаем обработку передаваемых данных, пусть передаются как есть
		processData: false,
		// отключаем установку заголовка типа запроса. Так jQuery скажет серверу что это строковой запрос
		contentType: false,
		// функция успешного ответа сервера
		success: function (respond, status, jqXHR) {

			// ОК - файлы загружены
			//				if (typeof respond.error === 'undefined') {
			// выведем пути загруженных файлов в блок '.ajax-reply'
//					alert(respond);
			var data = JSON.parse(respond);
			data = data[0];
			dd = data;
			ti = targetImp;
			tb = targetBg;
			$(targetImp).val(data.id);
			$(targetBg).css('background-image', "url('" + "download/" + data.id + "/" + encodeURIComponent(data.name) + "')");
			$(targetBg).css('background-size', 'cover');
		},
		// функция ошибки ответа сервера
		error: function (jqXHR, status, errorThrown) {
			console.log('ОШИБКА AJAX запроса: ' + status, jqXHR);
			aAlert("Ошибка загрузки файла!");
		},
	});

}

/**
 * Основная функция загрузки файлов (одним батчем).
 * Валидирует типы и размеры файлов, при необходимости подписывает их (ГосКлюч или криптопро),
 * затем отправляет на сервер через AJAX. После ответа добавляет файлы в список через fileAddArray/fileAddImgArray.
 * 
 * @param {HTMLInputElement} inp - Input[type=file].
 * @param {boolean} isImg - Если true, файлы добавляются как картинки (через fileAddImgArray).
 * @param {boolean} doSign - Если true, файлы будут подписаны ЭП перед отправкой.
 * @param {FileList|Array<File>} [dropFiles] - Если файлы пришли через Drag-and-Drop, они передаются здесь.
 */
async function fileChange(inp, isImg, doSign, dropFiles) {
	if (inp.value == "") {
		return;
	}
	// ничего не делаем если files пустой
	// создадим объект данных формы
//	console.log('file change', inp, isImg, doSign);
	var fileform = findParentByClassName(inp, 'fileform');
	var el = $(".filelist", fileform)[0];
	var loaded = $(".attfile", el).length;
	var maxSize = parseInt(el.dataset.size);
	var left_load = maxSize - loaded;
	var newLoadCount = inp.files.length;
	if (newLoadCount > left_load) {
		aAlert("Максимум " + maxSize + " файлов, осталось " + left_load + " файлов.");
		return;
	}

	var data = new FormData();
	if ($(inp).attr("data-image") === "") {
		data.append("img", "true");
	}

	var bar = $(".prg", fileform);
	var percent = $(".prc", fileform);

	bar.show().width(0);
	percent.show();

	var files = typeof dropFiles === 'object' ? dropFiles : inp.files;
	fff = files;
	if (!files && files.length == 0) {
		return;
	}

	var accept = inp.accept;
	if (!accept) {
		//chrome fix
		accept = $(inp).attr('accept');
	}

	accept = accept.toLowerCase().replace(/\./g, "").replace(/\ /g, "").split(",");

	let fullSize = 0;

	for (var key = 0; key < files.length; key++) {
		var value = files[key];
//		console.log("FILE", value);
		var ext = value.name.split(".").pop().toLowerCase();

		if (accept.indexOf(ext) === -1 && accept[0] !== "*") {
			aAlert("Недопустимый тип файла - '" + value.name + "'!");
			return;
		}

		if (typeof (value.size) === "number") {
			fullSize += value.size;
		}

		if (value.size > (MAX_FILE_SIZE_MB * 1024 * 1024)) {
			aAlert("Размер файла должен быть не больше " + MAX_FILE_SIZE_MB + " Мб!");
			return;
		}
//		console.log("APP", key, value);
		data.append(key, value);
	}

	if (fullSize >= 52428800) {
		aAlert("Размер загружаемых файлов (за раз) должен быть менее 50 Мб! Разделите загрузку файлов на несколько частей");
		return;
	}

	/**
	 * Срабатывает когда загружаем новый файл
	 */
	function post() {
		inp.value = "";
//		$(".loading-bar", fileform).show();
		FDD = data;
		var file_counter = 0;
		var name = null;
		var lastModified = 0;
		var type = "";
		var total_size = 0;

		data.forEach(function (item) {
			if (item instanceof File) {
				file_counter++;
				total_size += item.size;
				if (file_counter === 1) {
					name = item.name;
					type = item.type;
				} else {
					name = file_counter + " файла(ов)";
					type = null;
				}

			}
		});

		var file = {
			"name": name,
			"type": type,
			"size": total_size,
			"lastModified": lastModified
		};
		var upload_file_idx = UPLOAD_FILS.push(file, inp);
		jQuery.ajax({
			url: 'fileUpload',
			type: 'POST', // важно!
			data: data, // информация о подписи
			cache: false,
			dataType: 'html',
			// отключаем обработку передаваемых данных, пусть передаются как есть
			processData: false,
			// отключаем установку заголовка типа запроса. Так jQuery скажет серверу что это строковой запрос
			contentType: false,
			// функция успешного ответа сервера
			success: function (respond, status, jqXHR) {
				UPLOAD_FILS.done(upload_file_idx);
				bar.hide();
				percent.hide();

				var data = JSON.parse(respond); // если ошибка с подписью, то только один элемент в массиве, вне зависимости от количества подписываемых файлов

				ee = el;

				dd = data;
				if (isImg) {
					fileAddImgArray(data, el);
				} else {
					fileAddArray(data, el);
				}
				if (typeof fileOnload === "function") {
					fileOnload(data, el);
				}

				if (data && data.length === 1) {
					if (!data[0].success) {
						clearStoredCertificate(); // сбрасываем сертификат, если ошибка
					}
				}

				if (data && data[0].success) { //  если нет ошибки с подписью (проверяем только по первому элементу, так как можно загрузить только один + если ошибка то тоже один будет)
					if (window?.FUNCS?.DKP_Docs) { // очистка блоков с шаблонами в newComp
						const trDKP = findParentByClassName(inp, 'signfile_dog_kupprod');
						if (trDKP) {
							window.FUNCS.DKP_Docs.output.empty(); // удаляем блок с шаблонами
						}
					}
					if (typeof protocolsAction !== 'undefined' && data[0].success) { // замена протоколов
						const tr = findParentByClassName(inp, 'sf_container');
						if (tr) {
							protocolsAction(tr);
						}
					}
				}
			},
			// функция ошибки ответа сервера
			error: function (jqXHR, status, errorThrown) {
				UPLOAD_FILS.error(upload_file_idx);
				bar.hide();
				percent.hide();
				console.log('ОШИБКА AJAX запроса: ' + status, jqXHR);
				aAlert("Ошибка загрузки файла!");
			},

			xhr: function () {
				var myXhr = $.ajaxSettings.xhr();
				if (myXhr.upload) {
					// For handling the progress of the upload
					myXhr.upload.addEventListener('progress', function (e) {
						if (e.lengthComputable) {
							UPLOAD_FILS.progress(upload_file_idx, e);
							var percentComplete = Math.round(e.loaded / e.total * 100);
							var percentVal = percentComplete + '%';
							bar.width(percentVal);
							percent.html('Загрузка ' + percentComplete + '%...');
//							console.log("PROGRESS", e, percentComplete, bar, percent);
						}
					}, false);
				}
				return myXhr;
			}

		});

	}

	var useSelected = false;

	if (doSign) {
		ii = inp;
		var files = inp.files; // FileList object

		if (await checkGosKey()) {
			//Подпись файлов через ГосКлюч
			for (var i = 0; i < files.length; i++) {
				var fileInfo = getFileInfoFromName(files[i].name);
				if (!fileInfo.gosKeyAllowed) {
					await aAlert("Подписание данного типа документа не поддерживается Госключем! Поддерживаемые типы: " + Conf.get("goskey_allowed_ext").replaceAll(",", ", "));
					return;
				}
				if (fileInfo.fileExtChange && !await aConfirm("Госключ не поддерживает корректное отображение документов данного формата. При подписи в приложении может некорректно отображаться предпросмотр документа.", "Ознакомлен, продолжить подписание")) {
					return;
				}
			}


			var loaded = 0;
			var currentFileIdx = 0;
			function procesFile(fn) {
				var reader = new FileReader();
				var file = files[fn];
				reader.onload = function (e) {
					loaded++;
					currentFileIdx++;
					if (loaded !== files.length) {
						procesFile(currentFileIdx);
						return;
					}
					//Все загрузилось, отправляем на подпись
					SignGosKeyFiles(files, function (signData) {
						for (var i = 0; i < files.length; i++) {
							var filename = files[i].name.toGoskeyFileName();//.replaceAll(/ /gi, "_");
							data.append("sign" + i, signData[filename]);
						}
						post();
					});
				};
				reader.readAsBinaryString(file);
			}
			procesFile(currentFileIdx);
			return;
		}


		if (!isie || true) {
			//FF

			var currentFile = 0;
			function procesFile(fn) {
				console.log("processing file ", fn);
				var reader = new FileReader();
				var file = files[fn];
				// Closure to capture the file information.
				reader.onload = function (e) {
					var str;
					if (isie) {
						str = arrayBufferToString(e.target.result);
					} else {
						str = e.target.result;
					}


					Sign(str, true, false, function (sign) {
						if (sign) {
							data.append("sign" + fn, sign);
							currentFile++;
							if (files[currentFile]) {
								procesFile(currentFile);
							} else {
								post();
							}
							return true;
						} else {
							aAlert("Ошибка подписи файла!");
							return false;
						}
					}, useSelected);
					useSelected = true;
				};
				if (isie) {
					reader.readAsArrayBuffer(file);
				} else {
					reader.readAsBinaryString(file);
				}
			}
			procesFile(currentFile);

		} else {
			//IE
			var adod = activeXObject("ADODB.Stream");

			adod.open();
			adod.Type = 1;	// 1 - binary
			adod.LoadFromFile(x.value);
			var str = adod.Read();
			adod.Close();
			Sign(str, true, false, function (sign) {
				if (sign) {
					data.append("sign", sign);
					post();
					return true;
				} else {
					aAlert("Ошибка подписи файла!")
					return false;
				}
			});
		}
	} else {
		post();
		inp.value = "";
	}

	// AJAX запрос

}

/**
 * Преобразование ArrayBuffer в бинарную строку.
 * Используется для старых браузеров (IE), которые не поддерживают.readAsBinaryString().
 * @param {ArrayBuffer} buffer - Бинарный буфер.
 * @returns {string} Строковое представление бинарных данных.
 */
function arrayBufferToString(buffer) {

	var bufView = new Uint8Array(buffer);
	var length = bufView.length;
	var result = '';
	var addition = Math.pow(2, 16) - 1;

	for (var i = 0; i < length; i += addition) {

		if (i + addition > length) {
			addition = length - i;
		}
		result += String.fromCharCode.apply(null, bufView.subarray(i, i + addition));
	}

	return result;

}

var DEBUG_FILE_ARRAY = [];

/**
 * Загрузка файлов ПО ОДНОМУ (в очереди) с индивидуальным прогресс-баром для каждого.
 * Сортирует файлы по имени (чтобы "1.jpg" шло перед "10.jpg"), создает пустышки для каждого файла,
 * затем отправляет их последовательно. Используется для галерей с множеством фото.
 * 
 * @param {HTMLInputElement} inp - Input[type=file].
 * @param {boolean} isImg - Если true, файлы обрабатываются как изображения.
 * @param {boolean} isPdf - Если true, файлы обрабатываются как PDF.
 */
function fileChangeQueue(inp, isImg, isPdf, dropFiles) {
	var fileform = findParentByClassName(inp, 'fileform');
	var el = $(".filelist", fileform)[0];
	var loaded = $(".attfile", el).length;
	var maxSize = parseInt(el.dataset.size);
	var left_load = maxSize - loaded;
	// При drag-and-drop файлы приходят в dropFiles, а inp.files пуст — считаем по фактическому источнику.
	var newLoadCount = (typeof dropFiles === 'object' && dropFiles) ? dropFiles.length : inp.files.length;
	if (newLoadCount > left_load) {
		aAlert("Максимум " + maxSize + " файлов, осталось " + left_load + " файлов.");
		return;
	}
	var bar = $(".prg", fileform);
	var percent = $(".prc", fileform);
	var files = typeof dropFiles === 'object' ? dropFiles : inp.files;
	fff = files;
	if (!files && files.length == 0) {
		return;
	}

	let fullSize = 0;
	function post(porgress_bar, file, target) {
		//console.debug("POST FILE:", file, target);
		var upload_file_idx = UPLOAD_FILS.push(file, target);
		jQuery.ajax({
			url: 'fileUpload',
			type: 'POST', // важно!
			data: data,
			cache: false,
			dataType: 'html',
			// отключаем обработку передаваемых данных, пусть передаются как есть
			processData: false,
			// отключаем установку заголовка типа запроса. Так jQuery скажет серверу что это строковой запрос
			contentType: false,
			// функция успешного ответа сервера
			success: function (respond, status, jqXHR) {
//console.debug("FILE UPLOAD DONE", upload_file_idx, file);
				UPLOAD_FILS.done(upload_file_idx);
				bar.hide();
				percent.hide();
				var data = JSON.parse(respond);
				ee = el;
				dd = data;
				if (isImg || isPdf) {
					if (typeof (porgress_bar) !== "undefined") {
						filePostAddImgArray(data, porgress_bar, isPdf, file.name);
					} else {
						fileAddImgArray(data, el, isPdf);
					}
				} else {
					fileAddArray(data, el);
				}
				if (typeof fileOnload === "function") {
					fileOnload(data, el);
				}
			},
			// функция ошибки ответа сервера
			error: function (jqXHR, status, errorThrown) {
				//console.debug("FILE UPLOAD ERROR", upload_file_idx, file);
				UPLOAD_FILS.error(upload_file_idx);
				bar.hide();
				percent.hide();
				//console.info(jqXHR, status, file);
				//data.append();
				var data = [{"success": false, "name": file.name, "error": "Не удалось загрузить файл."}];
				if (isImg || isPdf) {
					if (typeof (porgress_bar) !== "undefined") {
						filePostAddImgArray(data, porgress_bar, isPdf);
					} else {
						fileAddImgArray(data, el, isPdf);
					}
				}
				//console.log('ОШИБКА AJAX запроса: ' + status, jqXHR);
				//mAlert("Ошибка загрузки файла!");
			},

			xhr: function () {
				var myXhr = $.ajaxSettings.xhr();
				if (myXhr.upload) {
					// For handling the progress of the upload
					myXhr.upload.addEventListener('progress', function (e) {
						if (e.lengthComputable) {
							UPLOAD_FILS.progress(upload_file_idx, e);
							//console.debug("FILE UPLOAD PROGRESS", upload_file_idx, file);
							var percentComplete = Math.round(e.loaded / e.total * 100);
							var percentVal = percentComplete + '%';
							if (typeof (porgress_bar) !== "undefined") {
								var prgb = $("#" + porgress_bar);
								var prc = $(".proc", prgb);
								prc.html(percentVal);
								var progress = $(".progress", prgb);
								//console.log(progress, $(".right .anim", progress));
								var degree = 360 / 100 * percentComplete;
								var deg_right = (degree <= 180 ? degree : 180);
								var deg_left = (degree > 180 ? degree - 180 : 0);
								$(".right .anim", progress).css({
									'-webkit-transform': 'rotate(' + deg_right + 'deg)',
									'-moz-transform': 'rotate(' + deg_right + 'deg)',
									'-ms-transform': 'rotate(' + deg_right + 'deg)',
									'-o-transform': 'rotate(' + deg_right + 'deg)',
									'transform': 'rotate(' + deg_right + 'deg)'
								});
								$(".left .anim", progress).css({
									'-webkit-transform': 'rotate(' + deg_left + 'deg)',
									'-moz-transform': 'rotate(' + deg_left + 'deg)',
									'-ms-transform': 'rotate(' + deg_left + 'deg)',
									'-o-transform': 'rotate(' + deg_left + 'deg)',
									'transform': 'rotate(' + deg_left + 'deg)'
								});
							} else {
								bar.width(percentVal);
								percent.html('Загрузка ' + percentComplete + '%...');
							}

							//console.log("PROGRESS ", e, percentComplete, bar, percent);
						}
					}, false);
				}
				return myXhr;
			}
		});
	}

	var arrayFiles = [];
	for (var i = 0; i < files.length; i++) {
		// files может быть FileList (inp.files) либо обычным массивом (drag-and-drop) — поддерживаем оба.
		arrayFiles[arrayFiles.length] = files.item ? files.item(i) : files[i];
	}
	DEBUG_FILE_ARRAY = arrayFiles;

	var arrayFilesSort = arrayFiles.sort(function (a, b) {
		var an = a.name.replace(/(^\d+)(.+$)/i, '$1');
		var bn = b.name.replace(/(^\d+)(.+$)/i, '$1');
		if (an === bn) {
			return (a.name < b.name ? -1 : (a.name > b.name ? 1 : 0));
		} else {
			an = an * 1;
			bn = bn * 1;
			return (an < bn ? -1 : (an > bn ? 1 : 0));
		}
	});
	for (var key = 0; key < arrayFilesSort.length; key++) {
		bar.show().width(0);
		percent.show();
		var data = new FormData();

		if ($(inp).attr("data-image") === "") {
			data.append("img", "true");
		}
		if ($(inp).attr("data-pdf") === "") {
			data.append("pdf", "true");
		}
		var file = arrayFilesSort[key];
		if (typeof (file.size) === "number") {
			fullSize += file.size;
		}

		if (file.size > (MAX_FILE_SIZE_MB * 1024 * 1024)) {
			aAlert("Размер файла должен быть не больше " + MAX_FILE_SIZE_MB + " Мб!");
			return;
		}
		data.append(key, file);
		var new_file_id = fileAddEmptyImgArray(el);
		post(new_file_id, file, inp);
	}
	inp.value = "";
}



/**
 * Переиндексация ВСЕХ списков файлов на странице.
 * Обновляет атрибуты name у скрытых input'ов, чтобы они корректно отправлялись на сервер массивами.
 * Также скрывает/показывает кнопку загрузки в зависимости от лимита.
 */
function fileReindexAll() {
	$('.filelist').each(function (n, el) {
		fileReindex(el);
	});
}

/**
 * Переиндексация конкретного списка файлов.
 * Критически важная функция: она переназначает атрибуты name у hidden input'ов (например, "files_0", "files_1"),
 * чтобы при отправке формы бэкенд получил корректный массив. Также удаляет "лишние" файлы, если их больше лимита,
 * и добавляет dummy-инпуты для пустых слотов.
 * 
 * @param {HTMLElement} filelist - DOM-элемент контейнера списка (.filelist).
 */
function fileReindex(filelist) {
	var doc_type = $(filelist).attr('data-doc-type');
	var is_array = $(filelist).attr('data-is-array');
	var size = $(filelist).attr('data-size');
	var is_imglist = $(filelist).hasClass("imglist");
	var fileform = $(filelist).parents('.fileform');
	var loadBtn = $(".sf_loadbtn", fileform);
	var n = (size > 1 ? "_" : "") + doc_type + (is_array ? '[]' : '');
	//console.log('oee is', filelist);
	var last = -1;
	$(".attfile", filelist).each(function (i, e) {
		//console.log("ien", i, e, n);
		last = i;
		var name = (size > 1 ? i : "") + n;
		if (i <= size - 1) {
			$("input[type=hidden]", e).attr("name", name);
			if (is_imglist) {
				$($("input[type=hidden]", e)[1]).attr("name", "rotate_" + name);
			} else {
				$($("input[type=hidden]", e)[1]).remove();
			}
		} else {
			$("input[type=hidden]", e).closest('.attfile').remove();
		}
	});
	$('.dummy', filelist).remove();
//	if (last + 1 >= size) {
//		//макс
//		$(filelist).parents(".filebody").find(".sf_loadbtn").hide();
//		var oldTitle = $(loadBtn).attr("title");
//		var oldOnClick = $(loadBtn).attr("onclick");
//		$(loadBtn).attr({"disabled": true, "data-title": oldTitle, "data-onclick": oldOnClick, "title": "Загружено максимальное количество файлов.", "onclick": "return false;"});
//		$(loadBtn).attr({"disabled": true, "data-title": oldTitle, "data-onclick": oldOnClick, "title": "Загружено максимальное количество файлов."});
//	} else {
//		//еще можно
//		var oldTitle = $(loadBtn).attr("data-title");
//		var oldOnClick = $(loadBtn).attr("data-onclick");
//		$(loadBtn).attr({"disabled": false, "title": oldTitle, "onclick": oldOnClick});
//		$(filelist).parents(".filebody").find(".sf_loadbtn").show();
//	}

	if (last >= size) {
		//переполнение
		aAlert("Максимальное количество файлов: " + size);
	}
	for (var i = last + 1; i < size; i++) {
		var dummy = $("<input class='dummy' type='hidden'>");
		$(dummy).attr("name", (size > 1 ? i : '') + n);
		dummy.appendTo(filelist);
		if (is_imglist) {
			var dummy_rot = $("<input class='dummy' type='hidden'>");
			$(dummy_rot).attr("name", "rotate_" + i + n);
			dummy_rot.appendTo(filelist);
		}
	}
	var filebody = findParentByClassName(filelist, 'filebody');
	if (filebody) {
		if (last > -1) {
			$(".btntitle", filebody).hide();
			$(filebody).addClass("completed");
		} else {
			$(".btntitle", filebody).show();
			$(filebody).removeClass("completed");
		}
	}
	updateAlpineStorage(filelist);
}

/**
 * Создание или обновление блока HTML с изображением/PDF.
 *
 * @param {Object} data - Данные файла с бэкенда.
 * @param {Object} [options]
 * @param {string}  [options.placeholderId] - ID пустышки (режим обновления после загрузки в очереди).
 *                                            Если не передан — создаётся новый блок.
 * @param {boolean} [options.asPdf=false]   - Файл как PDF.
 * @param {boolean} [options.isPost=false]  - Флаг для колбэка modMkImgCallback.
 * @returns {jQuery}
 */
function makeFilelistMediaItem(data, options = {}) {
	const {placeholderId, asPdf = false, isPost = false} = options;
	const isUpdateMode = !!placeholderId;
	const isCreateMode = !isUpdateMode;
	const isSuccessStatus = isCreateMode || data.success;

	let attfile;

	if (isUpdateMode) {
		attfile = $("#" + placeholderId);
		let btns = null;

		// --- Ветка ошибки (только для режима обновления) ---
		if (!data.success) {
			btns = $(`
			<div class='image_buttons'>
			    <span class='del' onclick='FK.fileDel(this)'></span>
			</div>
			`);

			var progress = $(".progress_bar", attfile).addClass("error");
			$(".anim", progress).css({"background": "#f15b5b", "transform": "rotate(0deg)"});
			$(".proc", progress).html("&#215;").css({
				"font-family": "Inter", "color": "#f15b5b",
				"font-size": "70px", "font-weight": "bold",
				"line-height": "40px", "padding-bottom": "10px"
			});
			var shadower = $("<div>" + data.name + "</div>").css({
				"display": "block", "position": "absolute",
				"left": 0, "top": 0, "right": 0, "bottom": 0,
				"text-align": "center", "color": "#fff", "font-size": "14px",
				"margin": "2px", "text-shadow": "0 0 3px #000", "word-wrap": "anywhere"
			});
			shadower.appendTo($("a", attfile));
		} else { // Успех — сносим содержимое пустышки
			$(".progress_bar", attfile).remove();
			$("a", attfile).remove();
			const a = $(TK.filesForm.fileLink());

			btns = $(TK.filesForm.imageButtons());
			a.appendTo(attfile);
			attfile.removeClass("empty");


		}
		btns.appendTo(attfile);
		if (typeof modMkImgCallback !== 'undefined') { // для editCompetitions1 (также используем для auth.canUploadMediaWithoutModeration в addFoto и newCompetitions)
			modMkImgCallback(attfile, data, true);
		}
	} else if (isCreateMode) { // --- Создание нового блока ---
		attfile = $(`
			<div class='attfile attimg new'>
			    <input type=hidden>
			    <input type=hidden>
			    ${TK.filesForm.fileLink()}
			    ${TK.filesForm.imageButtons()}
			</div>
		    `);
		var files_params = {};
		if (data.params && data.params.length > 0) {
			try {
				files_params = JSON.parse(data.params);
			} catch (e) {
				files_params = {};
			}
		}
		if (data.mod == "yes") {
			if (typeof (files_params.can_mod_edit) !== "undefined" && files_params.can_mod_edit !== true) {
				$(".image_buttons", attfile).remove();
			}
		}
	}

	// === Общая часть (только для успеха) ===
	if (isSuccessStatus) {
		// статус изображения
		if (!data.mod) {
			attfile.addClass("namoder");
		}
		if (data.mod == "no") {
			attfile.addClass("deny");
		}
		$($("input[type=hidden]", attfile)[0]).val(data.id);
		$($("input[type=hidden]", attfile)[0]).attr('data-val', data.id);
		$($("input[type=hidden]", attfile)[1]).val(data.rotate);
		$($("input[type=hidden]", attfile)[1]).attr('data-val', data.rotate);
		if (asPdf) {
			$("a", attfile).attr("href", "download/" + data.id + "/" + data.name);
			$(".pic", attfile).css({
				'background-image': "url('" + "download/" + data.id + "/" + data.name + "?preview')",
				'background-size': 'contain',
				'background-repeat': 'no-repeat'});
		} else {
			$("a", attfile).attr("href", "download/" + data.id + "/" + data.rotate + "_" + data.name);
			$(".pic", attfile).css('background-image', "url('" + "download/" + data.id + "/" + data.id + "_thumb_" + data.rotate + ".jpg')");
		}
	}

	return attfile;
}

// СТИЛИ ДЛЯ FILE ADD МОГУТ БЫТЬ НЕВЕРНЫМИ

/**
 * Добавление обычных файлов (документы, архивы и т.д.) в список.
 * Создает HTML-блоки с иконкой, названием, размером и информацией о подписи.
 * 
 * Контекст вызова:
 * 1. При инициализации страницы (attFileInit), когда файлы уже есть на сервере.
 * 2. При успешной загрузке через обычный fileChange (не в очереди).
 * 
 * @note data-init-list устанавливается через макросы velocity: 
 * @note получаем данные на странице $templUtil.getFiles($params.get("files"), "100879159")  → передаем как аргумент в вызов макроса #signfile_blue_table (параметр $signfile_file) → этот макрос внутри себя вызывает другой макрос #signfile_blue_body (параметр $signfile_file) → внутри последнего устанавливается атрибут с переданным аргументом для контейнера filelist 
 * @param {Array<Object>} data - Массив объектов с данными файлов с бэкенда  из атрибута data-init-list (id, name, size, sign_id и т.д.).
 * @param {HTMLElement} el - DOM-элемент контейнера списка файлов (обычно .filelist).
 */
function fileAddArray(data, el) {
	//console.log(data, 'data');

	/**
	 * Создание блока html с файлом 
	 * @param {type} data - данные файла
	 * @returns {$}
	 */
	function makeFilelistFileItem(data) {
		const params = {// параметры (можно прописать на странице)
			isLink: true, // файл можно открыть 
			isShowDate: window.CONSTANTS.SHOW_DATE_SIGNED_FILE === true, // показываем ли дату подписи файла (для редактирования торгов)
		};

		// определяем ссылку на файл
		let src = null;
		if (params.isLink) {
			src = getFilePath(data.id, data.name); // если что не так, то вернет null и выведется просто имя без ссылки
		}

		// определяем информацию о файле
		let fileInfoHtml = "";
		if (params.isShowDate) {
			fileInfoHtml = `
			<span style="display: flex; gap: 5px;">
				<span class=size></span>
				${params.isShowDate && data.date ? `<span class="date">${data.date}</span>` : ``}
			</span>
			`;
		} else { // если не показываем дату, то просто размер показываем
			fileInfoHtml = '<span class=size></span>';
		}

		const attfile = $(`
		<div class='attfile new'>
			<input type=hidden>
			<input type=hidden>
			<div class='icon'></div>
			<div class='body'>
				<div class=filecap>
					${params.isLink && src ? `<a href = '${src}' target = '_blank' rel = 'nofollow' class = title > </a>` : `<span class=title></span>`}
					<div class=rem></div>
					${fileInfoHtml}
					<span type='button' value='' class='del' onclick='FK.fileDel(this)'/></span>
				</div>
			<div class=certinfo></div>
			</div>
			${data.property !== undefined ? "<span class='hidden' file-property>" + data.property + "</span>" : ""}
		</div>
		`);

		$("input[type=hidden]", attfile).val(data.id);
		$("input[type=hidden]", attfile).attr('data-val', data.id);
		$(".title", attfile).html(data.name);

		const size = formatBytes(data.size);
		if (!size.split(" ").some(e => String(e).trim().toLowerCase() === 'nan' || String(e).trim().toLowerCase() === 'undefined')) {
			$(".size", attfile).html('[' + formatBytes(data.size) + ']');
		} else {
			PARAMS.isStage && console.warn("Некорректное значение в formatBytes:", data.size);
		}

		if (data.sign_id || data.signer) {
			if (isAuth) {
				$(".certinfo", attfile).html(" Подписано: <a href='#' onclick='show_sign(" + (data.sign_id !== void 0 ? data.sign_id + ", true" : data.id) + "); return false;'>" + data.signer + "</a>");
			} else {
				$(".certinfo", attfile).html(" Подписано: " + data.signer);
			}

		} else if (data?.signatures !== void 0) {
			for (var i = 0; i < data?.signatures.length; i++) {
				var sign = data?.signatures[i];
				var signInfo = $("<div class='certinfo-item'></div>");
				if (isAuth) {
					$(signInfo).html(" Подписано: <a href='#' onclick='show_sign(" + sign.id + ", true" + "); return false;'>" + sign.signer + "</a>");
				} else {
					$(signInfo).html(" Подписано: " + sign.signer);
				}
				$(".certinfo", attfile).append(signInfo);
			}
		}
		return attfile;
	}

	for (var i in data) {
		if (!data[i].success) {
			aAlert("Ошибка: " + data[i].error);
			console.log("ERR:", data[i].debug);
			break;
		}
		var attfile = makeFilelistFileItem(data[i]); // создаем html-блок
		if ($(el).hasClass("single")) {
			$(el).html('');
		}

		addFileToList(el, attfile); // Добавление файла в список
	}

	fileReindex(el);
}

/**
 * Добавление файла в список
 * @param {type} parent
 * @param {type} block
 * @returns {undefined}
 */
function addFileToList(parent, block) {
	const filelist = $(parent);
	const addBtn = $('.add-file-square', filelist);
	if (addBtn.length > 0) {
		block.insertBefore(addBtn);
	} else {
		block.appendTo(parent);
	}
}

/**
 * Создание "пустышки" (плейсхолдера) с круговым прогресс-баром для изображения/PDF, 
 * которое находится в процессе загрузки (используется в очереди fileChangeQueue).
 * 
 * Контекст вызова: Вызывается ПЕРЕД отправкой AJAX-запроса для каждого файла в очереди.
 * 
 * @param {HTMLElement} el - DOM-элемент контейнера списка (.filelist), куда добавить пустышку.
 * @returns {string} Уникальный ID (например, "emptyImg123456") созданного DOM-элемента пустышки. 
 *                   Этот ID нужно передать в filePostAddImgArray, чтобы обновить именно этот элемент.
 */
function fileAddEmptyImgArray(el) {
	//console.log("make Empty Img", el);
	var idx = "emptyImg" + Math.ceil(Math.random() * 100000000);
	var emptyFile = $("<div class='attfile attimg new empty' id=" + idx + ">"
		+ "<div class='progress_bar'>"
		+ "<div class='progress'>"
		+ "<div class='left'>"
		+ "<div class='anim'>"
		+ "</div>"
		+ "</div>"
		+ "<div class='right'>"
		+ "<div class='anim'>"
		+ "</div>"
		+ "</div>"
		+ "</div>"
		+ "<div class='proc'>0%</div>"
		+ "</div>"
		+ "<input type=hidden />"
		+ "<input type=hidden />"
		+ "<a target=_blank>"
		+ "<div class='palka' ondragover='return false;'></div>"
		+ "<div class='pic'></div>"
		+ "<div class='palka r' ondragover='return false;'></div>"
		+ "</a>"
		+ "</div>");

	addFileToList(el, emptyFile); // Добавление пустышки в список
	return idx;
}

/**
 * Обновление текстового счетчика "Загружено X фотографий из Y".
 * Вызывается после добавления или удаления фото в блоке лота.
 * 
 * @param {string|number} lotNumber - Номер лота (data-lotnum), для которого обновляется счетчик.
 */
function photoLoaded(lotNumber) {
	var parent = $(".photoBlock").parents('div[data-lotnum=' + lotNumber + ']');
	var photoLoaded = $(".imglist .attfile.attimg", parent).length;
	var totalLoad = $(".photoBlock").attr("data-size");
	var endWordFirst = endOfWordFirst(photoLoaded % 10, photoLoaded);
	var photoRest = totalLoad - photoLoaded;
	var endWordSecond = endOfWordSecond(photoRest % 10, photoRest);
	var zagruzeno = "Загружено";
	var lastDigit = photoLoaded % 10;
	if (lastDigit === 1 && photoLoaded != 11)
		zagruzeno = "Загружена";
	var quantity_div = "<div name='photoLoad_" + lotNumber + "'> " + zagruzeno + " " + photoLoaded + " фотограф" + endWordFirst + " из " + totalLoad + " возможных. Вы можете добавить еще " + photoRest + " фотограф" + endWordSecond + ".</div>";
	$('[name="photoLoad_' + lotNumber + '"]').remove();
	$(".photoBlock", parent).append(quantity_div);

	function endOfWordFirst(n, photoLoaded) {
		if (n === 1 && photoLoaded != 11)
			return "ия";
		else if ((n === 2 || n === 3 || n === 4) && (photoLoaded != 12 && photoLoaded != 13 && photoLoaded != 14))
			return "ии";
		else
			return "ий";
	}
	function endOfWordSecond(n, photoRest) {
		if (n === 1 && photoRest != 11)
			return "ию";
		else if ((n === 2 || n === 3 || n === 4) && (photoRest != 12 && photoRest != 13 && photoRest != 14))
			return "ии";
		else
			return "ий";
	}
}

/**
 * Инициализация Drag-and-Drop для сортировки изображений/PDF внутри списка.
 * Навешивает обработчики событий dragstart, dragenter, dragover, dragend, drop
 * на все элементы .attfile для возможности перетаскивания и изменения порядка.
 * 
 * @param {boolean} asPdf - Если true, ищется родитель .pdflist, иначе .imglist.
 */
function initImageDragAndDrop(asPdf) {
	// --- DRAG START: начало перетаскивания картинки внутри списка ---
	$(".attfile").attr("draggable", "true");
	$(".attfile").off("dragstart");
	$(".attfile").on("dragstart", function (ev) {
		isInternalImageDrag = true; // помечаем, что это внутренняя сортировка, а не файл извне
		var imglist = null;
		if (asPdf) {
			imglist = findParentByClassName(ev.target, 'pdflist');
		} else {
			imglist = findParentByClassName(ev.target, 'imglist');
		}
		$(imglist).addClass('dragging');
		$('.attfile .palka').css("visibility", "visible");

		draggedPic = ev.currentTarget;
		ev.originalEvent.dataTransfer.effectAllowed = "move";

		$(".divtrash").show();
		$(draggedPic).on('drag', function (ev) {
			ev.stopPropagation();
			ev.preventDefault();
			var pageX = ev.originalEvent.pageX;
			var pageY = ev.originalEvent.pageY;
			if (ev.originalEvent.x === 0 && ev.originalEvent.y === 0) {
				return false;
			}
			$(draggedPic).css({"position": "absolute", "top": (pageY + 10) + "px", "left": (pageX + 10) + "px", "z-index": "1000"});
		});
	});

	// --- DRAG ENTER: создание плейсхолдера при наведении на другую картинку ---
	$(".attfile").off("dragenter");
	$(".attfile").on("dragenter", function (ev) {
		// Игнорируем перетаскивание файлов ИЗВНЕ — плейсхолдер сортировки не нужен,
		// этим занимается отдельный обработчик внешнего drop ниже.
		if (!isInternalImageDrag) {
			return;
		}
		var cont = $(".attfile.dragenter");
		if (cont.length === 0) {
			cont = $("<div class='attfile attimg dragenter'></div>");
			draggedPic = ev.currentTarget;
			$(cont).on("dragover", function (ev) {
				ev.preventDefault();
				return false;
			});
			$(cont).on("drop", function (ev) {
				ev.stopPropagation();
				ev.preventDefault();
				if (!draggedPic) {
					$(ev.currentTarget).remove();
					return false;
				}
				$(draggedPic).insertBefore(ev.currentTarget);
				$(ev.currentTarget).remove();
				$(draggedPic).css({"position": "relative", "top": "0px", "left": "0px", "z-index": "0"});
				fileReindexAll();
			});
		}
		if ($(ev.currentTarget).prevAll(".dragenter").length !== 0) {
			$(cont).insertAfter(ev.currentTarget);
		} else {
			$(cont).insertBefore(ev.currentTarget);
		}
	});

	// --- DRAG END: завершение перетаскивания ---
	$(".attfile").off("dragend");
	$(".attfile").on("dragend", function (ev) {
		ev.stopPropagation();
		ev.preventDefault();
		isInternalImageDrag = false; // сбрасываем флаг внутренней сортировки
		var cont = $(".attfile.dragenter");
		if (cont.length !== 0) {
			$(cont).remove();
		}
		if (draggedPic) {
			$(draggedPic).css({"position": "relative", "top": "0px", "left": "0px", "z-index": "0"});
		}
	});

	// --- DROP на самом плейсхолдере ---
	$('.attfile.dragenter').off("drop");
	$('.attfile.dragenter').on("drop", function (ev) {
		ev.stopPropagation();
		ev.preventDefault();
		if (!draggedPic) {
			$(ev.currentTarget).remove();
			return false;
		}
		$(draggedPic).insertAfter(ev.currentTarget);
		fileReindexAll();
	});
}

/**
 * Обновление "пустышки" (созданной через fileAddEmptyImgArray) после завершения загрузки файла.
 * В зависимости от успеха заменяет прогресс-бар на картинку или отображает ошибку.
 * 
 * Контекст вызова: Вызывается в AJAX-колбэках (success/error) внутри fileChangeQueue.
 * 
 * ВНИМАНИЕ К ПАРАМЕТРАМ: В отличие от других функций, здесь `el` - это НЕ DOM-элемент контейнера, 
 * а СТРОКА с ID пустышки, которую вернула fileAddEmptyImgArray!
 * 
 * @param {Array<Object>} data - Массив объектов с данными файлов с бэкенда (или сфейковый массив с ошибкой).
 * @param {string} placeholderId - Уникальный ID (строка) DOM-элемента пустышки (например, "emptyImg123456").
 * @param {boolean} [asPdf=false] - Если true, файл обрабатывается как PDF.
 * @param {string} [fileName] - Имя файла (используется для отображения поверх картинки в случае ошибки).
 */
function filePostAddImgArray(data, placeholderId, asPdf, fileName) {
	var parent = $("#" + placeholderId).parents(".filelist");

	for (var i in data) {
		if (!data[i].success) {
			aAlert("Ошибка: " + data[i].error);
			console.log("ERR:", data[i].debug);
		}
		var attfile = makeFilelistMediaItem(data[i], {placeholderId: placeholderId, asPdf: asPdf, isPost: true}); // создаем html-блок изображения
		addFileToList(parent, attfile); // Добавление файла в список

		var new_div = "<div class='title'  style='position:relative;top:-100px; left:8px;width:100%;color:#fff; text-align:center;font-size:14px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;'>" + fileName + "</div>";
		$("#" + placeholderId).append(new_div);
		var parentLot = $("#" + placeholderId).parents("div[data-lotnum]");
		var lotNumber = parentLot.attr("data-lotnum");
		photoLoaded(lotNumber);
	}

	fileReindex(parent);

	initImageDragAndDrop(asPdf); // Инициализация Drag-and-Drop для сортировки изображений
}

/**
 * Добавление изображений или PDF-файлов в визуальный список (сетку).
 * Создает HTML-блоки с миниатюрами (превью), кнопками поворота/удаления.
 * Также навешивает глобальные обработчики Drag-and-Drop для сортировки картинок.
 * 
 * Контекст вызова:
 * 1. При инициализации страницы (attFileInit / dataFileInit).
 * 2. При успешной загрузке через обычный fileChange.
 * 
 * ВАЖНО: Используется, когда ответ с бэкенда уже получен и нужно сразу отрисовать финальный результат.
 * 
 * @param {Array<Object>} data - Массив объектов с данными файлов с бэкенда.
 * @param {HTMLElement} el - DOM-элемент контейнера списка (обычно .filelist или .imglist).
 * @param {boolean} [asPdf=false] - Если true, файл обрабатывается как PDF (ссылка и превью формируются иначе).
 */
function fileAddImgArray(data, el, asPdf) {

	for (var i in data) {
		if (!data[i].success) {
			aAlert("Ошибка: " + data[i].error);
			console.log("ERR:", data[i].debug);
			break;
		}
		var attfile = makeFilelistMediaItem(data[i], {asPdf: asPdf}); // создаем html-блок

		addFileToList(el, attfile); // Добавление файла в список

		if (typeof modMkImgCallback !== 'undefined') { // для editCompetitions1
			modMkImgCallback(attfile, data[i], false);
		}

		var parents = $(".attfile").parents('.gray-block');
		var lotNumber = parents.attr("data-lotnum");
		photoLoaded(lotNumber);
	}

	fileReindex(el);

	initImageDragAndDrop(asPdf); // Инициализация Drag-and-Drop для сортировки изображений
}

/**
 * Обработчик входа перетаскиваемого файла в зону загрузки.
 * Добавляет класс "drag" для визуальной подсветки зоны.
 * @param {HTMLElement} filebody - Зона загрузки (.filebody).
 * @param {DragEvent} e - Событие dragenter.
 */
function fileDragEnter(filebody, e) {
	e.preventDefault();
	$(filebody).addClass("drag");
}

/**
 * Обработчик выхода перетаскиваемого файла из зоны загрузки.
 * Убирает класс "drag".
 * @param {HTMLElement} filebody - Зона загрузки (.filebody).
 * @param {DragEvent} e - Событие dragleave.
 */
function fileDragExit(filebody, e) {
	e.preventDefault();
	$(filebody).removeClass("drag");
}

/**
 * Обработчик сброса файлов в зону загрузки (Drop).
 * Извлекает файлы из dataTransfer и передает их в fileChange.
 * @param {HTMLElement} filebody - Зона загрузки (.filebody).
 * @param {DragEvent} e - Событие drop.
 */
function fileDrop(filebody, e) {
	e.preventDefault();
	e.stopPropagation(); // Важно: останавливаем всплытие
	$(filebody).removeClass("drag");
	var inp = $("input[type=file]", filebody)[0];

	var files = [];

	// более надёжный и универсальный API
	if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
		for (var i = 0; i < e.dataTransfer.files.length; i++) {
			files.push(e.dataTransfer.files[i]);
		}
	}
	// Fallback для dataTransfer.items (если files не доступен)
	else if (e.dataTransfer.items) {
		for (var i = 0; i < e.dataTransfer.items.length; i++) {
			if (e.dataTransfer.items[i].kind === 'file') {
				var file = e.dataTransfer.items[i].getAsFile();
				if (file)
					files.push(file);
			}
		}
	}

	if (files.length > 0) {
		// Определяем тип загрузки по классам контейнера
		var isImg = $(filebody).find('.filelist').hasClass('imglist');
		var isPdf = $(filebody).find('.filelist').hasClass('pdflist');

		fileChange(inp, isImg || isPdf, false, files);
	}

	return false;
}


/**
 * Инициализация списка файлов при загрузке страницы.
 * Парсит JSON из атрибута data-init-list (который генерируется Velocity-шаблоном на бэкенде)
 * и отрисовывает файлы через fileAddArray или fileAddImgArray в зависимости от типа списка.
 * 
 * @param {HTMLElement} el - DOM-элемент контейнера списка (.filelist).
 */
function attFileInit(el) {
	var data = [];
	try {
		data = JSON.parse($(el).attr('data-init-list'));
	} catch (exception) {
		console.log("unable to parse", $(el).attr('data-init-list'));
	}
	for (var i in data) {
		data[i].success = true;
	}
	if ($(el).hasClass("imglist") || $(el).hasClass("pdflist")) {
		fileAddImgArray(data, el, $(el).hasClass("pdflist"));
	} else {
		fileAddArray(data, el);
	}
}

/**
 * Программная инициализация списка файлов из переданного JSON-массива (без использования data-атрибута).
 * Используется, когда данные о файлах получены динамически (например, через AJAX).
 * 
 * @param {Array<Object>} data - Массив объектов с данными файлов.
 * @param {HTMLElement} el - DOM-элемент контейнера списка (.filelist).
 * @param {'img'|'pdf'|'file'} type - Тип списка: 'img' для картинок, 'pdf' для PDF, 'file' для обычных документов.
 * @returns {null|undefined} Возвращает null в случае ошибки валидации данных.
 */
function dataFileInit(data, el, type) {
	if (!Array.isArray(data)) {
		console.error("Данные должны быть переданы массивом");
		return null;
	}

	for (var i in data) {
		data[i].success = true;
	}

	switch (type) {
		case 'img':
			fileAddImgArray(data, el, false);
			break;
		case 'pdf':
			fileAddImgArray(data, el, true);
			break;
		default:
			fileAddArray(data, el);
	}
}
;


/**
 * Полное удаление всех файлов из списка.
 * @param {HTMLElement} filelist - DOM-элемент контейнера списка (.filelist).
 */
function attFileDelAll(filelist) {
	var $attfiles = $(".attfile", filelist);
	$attfiles.each(function (i, attfile) {
		if ($(attfile).hasClass("new")) {
			$(attfile).remove();
		} else {
			$("input[type=hidden]", attfile).val('');
			$(attfile).addClass('removed');
		}
	});
	fileReindex(filelist);
}

/**
 * Метод получения пути к файлу для скачивания/просмотра.
 * (основан на работе метода из сервлета fileUpload)
 * @param {string|number} fileId - Уникальный идентификатор файла на сервере.
 * @param {string} fileName - Оригинальное имя файла (будет закодировано через urlencode).
 * @returns {string|null} Путь вида "download/{id}/{encoded_name}" или null, если имя пустое.
 */
function getFilePath(fileId, fileName) {
	const url = urlencode(fileName); // форматируем в url
	if (!url) {
		return null;
	}

	return "download/" + fileId + "/" + urlencode(fileName);
}


$(function () {
	$(".filelist").each(function (n, el) { // для каждого списка файлов инициализируем сохраненные файлы при загрузке
		attFileInit(el);
	});

	initMediaFormExternalDrop();
});

/**
 * Drag-and-Drop файлов ИЗВНЕ для медиа-форм (.imgform / .pdfform).
 * навешиваем делегированные обработчики на саму .fileform, чтобы корректно перехватить внешний drop и передать файлы в fileChangeQueue.
 */
function initMediaFormExternalDrop() {
	// Селектор медиа-форм (картинки и pdf). Именно у них нет .filebody.
	var MEDIA_FORM_SELECTOR = ".fileform.imgform, .fileform.pdfform";

	function isExternalFileDrag(ev) {
		// Внутренняя сортировка картинок
		if (isInternalImageDrag) {
			return false;
		}
		var dt = (ev.originalEvent || ev).dataTransfer;
		if (!dt) {
			return false;
		}
		// При перетаскивании файлов из ОС в types присутствует "Files".
		if (dt.types) {
			return Array.prototype.indexOf.call(dt.types, "Files") !== -1;
		}
		return true;
	}

	// dragover/dragenter: обязательно preventDefault, иначе drop не сработает,
	// а браузер откроет файл в новой вкладке.
	$(document).on("dragover dragenter", MEDIA_FORM_SELECTOR, function (ev) {
		if (!isExternalFileDrag(ev)) {
			return;
		}
		ev.preventDefault();
		ev.stopPropagation();
		(ev.originalEvent || ev).dataTransfer.dropEffect = "copy";
		$(this).addClass("drag");
	});

	$(document).on("dragleave", MEDIA_FORM_SELECTOR, function (ev) {
		if (!isExternalFileDrag(ev)) {
			return;
		}
		// Убираем подсветку только когда курсор реально покинул форму,
		// а не перешёл на дочерний элемент.
		var related = (ev.originalEvent || ev).relatedTarget;
		if (related && this.contains(related)) {
			return;
		}
		$(this).removeClass("drag");
	});

	$(document).on("drop", MEDIA_FORM_SELECTOR, function (ev) {
		if (!isExternalFileDrag(ev)) {
			return;
		}
		ev.preventDefault();
		ev.stopPropagation();
		$(this).removeClass("drag");

		var dt = (ev.originalEvent || ev).dataTransfer;
		var files = [];
		if (dt.files && dt.files.length > 0) {
			for (var i = 0; i < dt.files.length; i++) {
				files.push(dt.files[i]);
			}
		} else if (dt.items) {
			for (var j = 0; j < dt.items.length; j++) {
				if (dt.items[j].kind === "file") {
					var f = dt.items[j].getAsFile();
					if (f) {
						files.push(f);
					}
				}
			}
		}

		if (files.length === 0) {
			return;
		}

		var inp = $("input[type=file]", this)[0];
		if (!inp) {
			return;
		}

		var isPdf = $(".filelist", this).hasClass("pdflist");
		var isImg = $(".filelist", this).hasClass("imglist");
		// Медиа-формы грузят файлы по очереди через fileChangeQueue.
		fileChangeQueue(inp, isImg, isPdf, files);
	});
}
